import React, { forwardRef, useImperativeHandle } from "react";
import { useFormik } from "formik";
import { useEUFormConfig } from "../../hooks/useEUFormConfig";
import { CountryContext } from "./CountryContext"
import { EURO_COUNTRIES } from "../Common/constants";
import { getTransArr } from "../Common/utils";
import { useTranslation } from "react-i18next";
import EuroForm from "./EuroForm";

const FormikContainer = forwardRef(({ modifyUser, user, handleUser, userIndex }, ref) => {

  const { initialValues, validationSchema } = useEUFormConfig({ user, modifyUser });
  const { t } = useTranslation("common");

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
  });

  const handleSubmit = async () => {
    const allFields = Object.keys(initialValues);
    const fieldsToTouch = allFields.reduce((acc, key) => ({ ...acc, [key]: true }), {});
    await formik.setTouched(fieldsToTouch, true);
    const errors = await formik.validateForm();
    const values = { ...formik.values };
    if (values.day && values.month) {
      const day = values.day.length === 1 ? `0${values.day}` : values.day;
      const month = values.month.length === 1 ? `0${values.month}` : values.month;
      values.day = day;
      values.month = month;
      values.birthMonthDay = `${day}/${month}`;
      values.verificationPin = `${day}${month}`;
      if (values.year) {
        values.fullDateOfBirth = `${day}/${month}/${values.year}`;
      }
    }
    handleUser(values);
    return Object.keys(errors).length === 0;
  };

  useImperativeHandle(ref, () => ({
    submitForm: handleSubmit,
    getValues: () => formik.values,
  }));

  const initialContextValues = {
    selectedCountry: user.country,
    isModifyUser: modifyUser,
    userIndex,
  };

  const transEuroCountries = getTransArr(Array.from(EURO_COUNTRIES), t);
  const isEuro = transEuroCountries.includes(user.country);

  return (
    <CountryContext.Provider value={initialContextValues}>
      <form id="formContainer" onSubmit={handleSubmit} autoComplete="off" ref={ref}>
        {
          isEuro && (
            <EuroForm formik={formik} user={user} isModifyUser={modifyUser} />
          )
        }
      </form>
    </CountryContext.Provider>
  );
});

export default FormikContainer;
